import * as React from "react";
const SvgParentRealign = props => <svg xmlns="http://www.w3.org/2000/svg" width={13} height={12} fill="none" viewBox="0 0 13 12" {...props}><path d="m4.75.75-4.5 4.5 1.065 1.065L4 3.622V12h9v-1.5H5.5V3.623l2.685 2.692L9.25 5.25z" /></svg>;
export default SvgParentRealign;